export const INCIDENT_EXECUTION_UPDATED_EVENT = 'kloudsecure:incident-execution-updated';

export function notifyIncidentExecutionUpdated(incidentId: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(INCIDENT_EXECUTION_UPDATED_EVENT, { detail: { incidentId } }));
}
